import React from "react";
// import { useEffect, useRef, useState } from "react";
// import { App } from "../3D/app";
// import { MainMenu } from "./HomeMenu/MainMenu";
// import ObserverEmitter, { EVENTS } from "../emitter/Observer";
// // import { TooltipsMenu } from "./HomeMenu/TooltipsMenu";
// import { Outlet } from "react-router-dom";
// import { LoadingGiff } from "../components/common/LoadingGiff";
// import { AlertDeviceLandscape } from "../components/helpers/AlertDeviceLandscape";
// import { LoadingSceneGiff } from "../components/common/LoadingSceneGiff";

function Home() {
	// const [menuVisible, setMenuVisible] = useState(true);
	// const containerRef = useRef(null);
	// const pointOne = useRef(null);
	// const pointTwo = useRef(null);
	// const pointThree = useRef(null);
	// const pointFour = useRef(null);
	// const pointFive = useRef(null);
	// const pointSix = useRef(null);
	// const pointSeven = useRef(null);

	// useEffect(() => {
	// 	if (!containerRef.current.iscreated) {
	// 		containerRef.current.iscreated = true;
	// 		const container = containerRef.current;
	// 		const app = new App(container, [
	// 			pointOne.current,
	// 			pointTwo.current,
	// 			pointThree.current,
	// 			pointFour.current,
	// 			pointFive.current,
	// 			pointSix.current,
	// 			pointSeven.current,
	// 		]);
	// 		app.onResized();
	// 	}

	// 	// para ocultar el UI del menu cuando cargen actividades
	// 	// eslint-disable-next-line

	// 	ObserverEmitter.on(EVENTS.loadingCompleteScene, () => {
	// 		setMenuVisible(false);
	// 		ObserverEmitter.emit(EVENTS.hiddenMenusAnimations);
	// 	});
	// 	ObserverEmitter.on(EVENTS.init_introduction, () => {
	// 		setMenuVisible(false);
	// 		ObserverEmitter.emit(EVENTS.hiddenMenusAnimations);
	// 	});
	// 	// ----------------------------------------

	// 	ObserverEmitter.on(EVENTS.init_mainMenu, () => {
	// 		setMenuVisible(true);
	// 		ObserverEmitter.emit(EVENTS.showMenuAnimations);
	// 	});
	// }, []);

	// return (
	// 	<div className="fixed top-0 w-full h-full z-0 bg-[#E5E5E5] flex ">
	// 		<LoadingGiff></LoadingGiff>
	// 		<LoadingSceneGiff></LoadingSceneGiff>
	// 		<AlertDeviceLandscape></AlertDeviceLandscape>
	// 		<div
	// 			ref={containerRef}
	// 			id="container"
	// 			className={`cursor-grab ${menuVisible ? "w-100-212 md:w-100-470 " : "w-full"} h-full bg-[#E5E5E5]`}
	// 		></div>
	// 		<Outlet />
	// 		<MainMenu></MainMenu>
	// 		{/* tootltips in 3D */}
	// 		{/* <TooltipsMenu
	// 			pointOne={pointOne}
	// 			pointTwo={pointTwo}
	// 			pointThree={pointThree}
	// 			pointFour={pointFour}
	// 			pointFive={pointFive}
	// 			pointSix={pointSix}
	// 			pointSeven={pointSeven}
	// 		></TooltipsMenu> */}
	// 	</div>
	// );
	return (
		<></>
	)
}

export default Home;
